import React, { forwardRef, useEffect } from 'react';
import { FiltersContent } from './components';
import { useTrackModalOpened } from './hooks';

type FiltersModalProps = {
  onRequestClose: () => void;
  selectedApplicationsTab: 'matched' | 'other';
  visible: boolean;
};

export const FiltersModal = forwardRef(
  (
    { onRequestClose, selectedApplicationsTab, visible }: FiltersModalProps,
    ref
  ) => {
    const trackModalOpened = useTrackModalOpened({
      userIsViewingApplicantsType: selectedApplicationsTab
    });

    useEffect(
      () => {
        visible && trackModalOpened();
      },
      [visible] /* eslint-disable-line react-hooks/exhaustive-deps */
    );

    return (
      <FiltersContent
        ref={ref}
        visible={visible}
        onRequestClose={onRequestClose}
      />
    );
  }
);
